import type ISchoolRepository from '@/core/domain/school/core/ISchoolRepository'
import School, { SchoolInput, SchoolMe } from '@/core/domain/school/core/School'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory'

export default class SchoolRepository implements ISchoolRepository {
  async fetchSchoolById(schoolId: number): Promise<School> {
    const response = await apiService.get(`admin/schools/${schoolId}`)
    return School.create(response.data)
  }

  async fetchSchoolsForMe(): Promise<SchoolMe[]> {
    const response = await apiService.get('admin/schools/me')

    if (!Array.isArray(response.data)) {
      throw new Error('Expected array response for schools me')
    }

    return response.data.map((school) => SchoolMe.create(school))
  }

  async fetchAllSchools(): Promise<School[]> {
    const response = await apiService.get('admin/schools')

    if (!Array.isArray(response.data)) {
      throw new Error('Expected array response for schools')
    }

    return response.data.map((school) => School.create(school))
  }

  async createSchool(school: SchoolInput): Promise<School> {
    const response = await apiService.post('admin/schools', school.schoolInput)
    return School.create(response.data)
  }

  async updateSchool(schoolId: number, school: SchoolInput): Promise<School> {
    const response = await apiService.put(`admin/schools/${schoolId}`, school.schoolInput)
    return School.create(response.data)
  }
}
